export const v1IncidentKeys = {
  base: ['v1Incident'] as const,
  get: (id: string) => [...v1IncidentKeys.base, id] as const,
};
